<template>
	<div class="main staff">
		<div class="g-mnc g-mnc-kefu">
			<div class="sidebar">
				<div class="service-content">
					<!--<div class="u-sideBar-title">个人信息</div>-->

					<ul class="tabs">
						<li
							:class="item.class"
							@click="cutover(menus,index)"
							v-for="(item,index,) in menus"
						>{{item.message}}</li>
					</ul>
				</div>
			</div>
			<div class="content">
				<div :is="movement"></div>
			</div>
		</div>
	</div>
</template>

<script>
import infor from '@/components/manage/setting/infor'
import reply from '@/components/manage/setting/reply'
import remind from '@/components/manage/setting/remind'
import assess from '@/components/manage/setting/assess'
import channel from '@/components/manage/setting/channel'
import ChannelProblem from '@/components/manage/setting/ChannelProblem'
import consultingTypeList from './ConsultingTypeList.vue';
import ContactSpecifications from './ContactSpecifications.vue';
import Crisis from './Crisis.vue'
import ProductList from './ProductList.vue';
export default {
	name: 'setting',
	props: [],
	data() {
		return {
			movement: 'infor',
			menus: [
				{
					class: 'current',
					message: '个人信息',
					components:'infor'
				},
				{
					class: '',
					message: '快捷回复',
					components:'reply'
				},
				{
					class: '',
					message: '自动提醒',
					components:'remind'
				},
				{
					class: '',
					message: '用户评价',
					components:'assess'
				},
				{
					class: '',
					message: '渠道',
					components:'channel'
				},
				{
					class: '',
					message: '快捷问题',
					components:'ChannelProblem'
				},
				{
					class:'',
					message:'联络原因',
					components:'consultingTypeList'
				},
				{
					class:'',
					message:'产品名称',
					components:'ProductList'
				},
				{
					class:'',
					message:'联系规格',
					components:'ContactSpecifications'
				},
				{
					class:'',
					message:'危机程度',
					components:'Crisis'
				}
			]
		}
	},
	watch: {},
	mounted: function() {},
	methods: {
		cutover(menus, index) {
			for (let i = 0; i < menus.length; i++) {
				menus[i].class = ''
			}
			menus[index].class = 'current'
			this.movement=menus[index].components;
			// if (index == 0) {
			// 	this.movement = 'infor'
			// } else if (index == 1) {
			// 	this.movement = 'reply'
			// } else if (index == 2) {
			// 	this.movement = 'remind'
			// } else if (index == 3) {
			// 	this.movement = 'assess'
			// } else if (index == 4) {
			// 	this.movement = 'channel'
			// } else if(index==5){
			// 	this.movement = 'ChannelProblem'
			// }
		}
	},
	components: {
		infor,
		reply,
		remind,
		assess,
		channel,
		ChannelProblem,
		consultingTypeList,
		ContactSpecifications,
		Crisis,
		ProductList
	}
}
</script>

<style scoped>
.main {
	flex: 1;
	display: flex;
	flex-direction: column;
	height: 100%;
	position: relative;
	background-color: #fff;
}
.g-mnc {
	display: flex;
	flex: 1;
	flex-direction: row;
	padding: 40px;
	box-sizing: border-box;
}
.g-mnc-kefu {
	position: relative;
	-moz-border-radius: 2px;
	border-radius: 2px;
	box-sizing: border-box;
	flex-direction: column;
	height: calc(40%);
	padding: 0 0 0 0px;
	display: flex;
	flex-direction: row;
}
.content-main {
	display: flex;
	position: relative;
	/* height: calc(100% - 60px);*/
	height: 100%;
}
.g-mnc-kefu .sidebar {
	height: 100%;
}
.service-content {
	width: 210px;
	transition: width 0.2s;
	background: #f7f8fa;
	overflow-x: hidden;
	overflow-y: auto;
	height: 100%;
}
.g-mnc-kefu .content {
	height: 100%;
	overflow: auto;
	display: flex;
	flex-direction: column;
	position: relative;
	/* padding: 0 30px; */
	padding-right: 30px;
	padding-left: 15px;
	padding-top: 10px;
	width: 100%;
	box-sizing: border-box;
}
.u-sideBar-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 18px;
	color: #222;
	padding: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}

.tabs li {
	background-color: #f7f8fa;
	line-height: 50px;
	padding-left: 20px;
}
.tabs li.current {
	background-color: #edeef0;
	color: #337eff;
	border-right: 3px solid #337eff;
}
/*子菜单*/
.el-menu {
	background-color: #f7f8fa;
}
.is-active {
	background-color: #edeef0;
	border-right: 3px solid #337eff;
}
/**/
.contains {
	height: 100%;
	overflow: auto;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	-ms-flex-direction: column;
	flex-direction: column;
	position: relative;
	padding-top: 10px;
	width: 100%;
	-webkit-box-sizing: border-box;
	box-sizing: border-box;
}
.content-tit {
	height: 60px;
	line-height: 46px;
}
.content-tit h2 {
	font-weight: normal;
	font-size: 24px;
}
.content-main {
	display: flex;
	position: relative;
	/* height: calc(100% - 60px);*/
	height: 100%;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/manage/setting/setting.vue